import React from "react";
import "assets/img/Logo.png"
// reactstrap components
import {
  Form,
  FormGroup,
  Input,
  Button,
  Row,
  Col
} from "reactstrap";

class SignUp extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      fullName: "",
      hubID: "",
      email: "",
      phoneNumber:"",
      createPassword: "" ,
      confirmPassword: "",
    };
  }
  render() {
    return (
      <div className="contentLogin">

      <img className="logo" src={ require("assets/img/Logo.png") } />
          <Form>
          <Row>
              <Col md={{ size: 4, offset: 1}} lg={{ size: 4, offset: 1}} xl={{ size: 4, offset: 1 }} >
            <FormGroup>
              <Input
                type="text"
                id="fullName"
                placeholder="Full Name"
                style={{width: '80%'}}
              />
            </FormGroup>
            </Col>
              <Col md={{ size: 4, offset: 1}} lg={{ size: 4, offset: 1}} xl={{ size: 4, offset: 1 }}>
            <FormGroup>
            <Input
              type="text"
              id="hubID"
              placeholder="Hub ID"
              autoComplete="off"
              style={{width: '80%'}}
            />
          </FormGroup>
          </Col>
          </Row>
          <Row>
            <Col md={{ size: 4, offset: 1}} lg={{ size: 4, offset: 1}} xl={{ size: 4, offset: 1 }}>
          <FormGroup>
            <Input
              type="email"
              id="email"
              placeholder="Email"
              style={{width: '80%'}}
            />
        </FormGroup>
        </Col>
          <Col md={{ size: 4, offset: 1}} lg={{ size: 4, offset: 1}} xl={{ size: 4, offset: 1 }}>
        <FormGroup>
          <Input
            type="text"
            id="phoneNumber"
            placeholder="Phone Number"
            style={{width: '80%'}}
          />
      </FormGroup>
      </Col>
      </Row>
      <Row>
        <Col md={{ size: 4, offset: 1}} lg={{ size: 4, offset: 1}} xl={{ size: 4, offset: 1 }}>
      <FormGroup>
        <Input
          type="password"
          id="createPassword"
          placeholder="Create Password"
          style={{width: '80%'}}
        />
    </FormGroup>
    </Col>
      <Col md={{ size: 4, offset: 1}} lg={{ size: 4, offset: 1}} xl={{ size: 4, offset: 1 }}>
    <FormGroup>
      <Input
        type="password"
        id="confirmPassword"
        placeholder="Confirm Password"
        style={{width: '80%'}}
      />
  </FormGroup>
  </Col>
  </Row>
  <Row>
  <Col sm={{ size: 3, offset: 4 }} md={{ size: 3, offset: 4 }}>
  <Button className="test" href="#/user/dash"> Sign Up </Button>
  </Col>
  </Row>
        </Form>
      </div>
    );
  }
}
export default SignUp;
